import type React from 'react';
import { Button } from '../../core/Button';
import styles from './PricingTable.module.css';

export const PricingTable: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <h1 className={styles.title}>Pricing</h1>
        <p className={styles.subtitle}>Choose the plan that's right for you.</p>
      </div>
      <div className={styles.table}>
        <div className={styles.column}>
          <div className={styles.columnContent}>
            <h2>Free</h2>
            <p className={styles.price}>$0/month</p>
            <p className={styles.description}>
              Perfect for hobbyists and those just getting started.
            </p>
            <ul>
              <li>Embed as an animated GIF</li>
              <li>Access to 2D shaders</li>
              <li>1 project</li>
            </ul>
          </div>
          <div className={styles.columnFooter}>
            <Button variant="secondary">
              <a href="/signup">Get Started</a>
            </Button>
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.columnContent}>
            <h2>Paid</h2>
            <p className={styles.price}>$5/month</p>
            <p className={styles.description}>
              For professionals who need more power and flexibility.
            </p>
            <ul>
              <li>Embed as native canvas and shader</li>
              <li>Access to 2D and 3D shaders</li>
              <li>Save projects</li>
              <li>Unlimited projects</li>
            </ul>
          </div>
          <div className={styles.columnFooter}>
            <Button>
              <a href="/signup">Get Started</a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
